export const getWindowLocationPathname = () => window.location.pathname;
export const getWindowLocationSearch = () => window.location.search;
export const getWindowLocation = () => window.location;
export const getWindowHistory = () => window.history;
export const getWindowOrigin = () => window.origin;